import React from 'react'

export default function OrderInfoCard({ subtitle, children, onEdit }) {
  return (
    <div className="bg-white rounded-2xl p-6 w-full text-center">
      <p className="text-sm text-gray-500 mb-1">{subtitle}</p>
      <p className="text-4xl font-bold text-sky-900">{children}</p>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="mt-3 text-sm text-sky-600 hover:text-sky-800 font-medium underline"
        >
          Change
        </button>
      )}
    </div>
  )
}
